<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div class="main-container">

        <div class="back-route" @click.stop="router.push('/management/courses')"><i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>

        <div class="preregistrations" v-if="dataLoaded">
            <template v-if="true">
                <div class="new-and-filter">
                    <h3>Usuarios Forge</h3>
                </div>
                <div class="cohorte_data">
                    <span>Curso: <strong>{{courseName}}</strong></span>
                    <button :disabled="route.query.canBeManaged == 'false'" @mouseover="tooltipAddUser = true" @mouseleave="tooltipAddUser = false"
                    @click="modalAddUser.active = true; modalAddUser.currentStep = 1; modalAddUser.error = false; modalAddUser.errorType = ''; modalAddUser.success = false; modalAddUser.successEmail = ''; modalAddUser.successRoleName = '';" class="create-new"><i class="material-icons">add_circle</i>
                        Agregar nuevo usuario
                        <Tooltip v-if="tooltipAddUser && route.query.canBeManaged == 'false'" message="Esta acción debe ser realizada desde el Sistema de Gestión" color="black" />
                    </button>
                </div>

                <div ref="table" class="table-pagination">
                    <div class="table__container">
                        <table class="table">
                            <thead class="table__head">
                                <tr class="table__head__row">
                                    <th class="table__head__row__fullname">USUARIO</th>
                                    <th class="table__head__row__email">MAIL</th>
                                    <th class="table__head__row__role">ROL</th>
                                    <th class="table__head__row__date">ÚLTIMO ACCESO</th>
                                    <th class="table__head__row__options"></th>
                                </tr>
                            </thead>
                            <tbody class="table__body">
                                <tr class="table__body__row" v-for="(row, index) in users" :key="index">
                                    <td class="table__body__row__fullname">
                                        {{ row.fullname }}
                                    </td>
                                    <td class="table__body__row__email">
                                        {{ row.email }}
                                    </td>
                                    <td class="table__body__row__role">
                                        {{$t(`role.${row.role}`)}}
                                        
                                    </td>
                                    <td class="table__body__row__date">{{ row.lastLogin ? formatDate(row.lastLogin) : '-' }}</td>
                                    <td class="table__body__row__options" v-if="route.query.canBeManaged != 'false'"
                                        @click.stop="openDeleteUserModal(row.id, row.fullname)"
                                    >
                                        <i class="material-icons">delete_outline</i>
                                    </td>
                                    <td class="table__body__row__options" v-else style="position: static; cursor: default;" @mouseover="tooltipDeleteUser = true" @mouseleave="tooltipDeleteUser = false">
                                        <i class="material-icons" style="opacity: .5;">delete_outline</i>
                                        <Tooltip v-if="tooltipDeleteUser" message="Esta acción debe ser realizada desde el Sistema de Gestión" color="black" />
                                    </td>

                                    
                                   
                                    <Modal :isOpen="deleteUserModal.active" @close="closeDeleteUserModal" class="modal-certificate">
                                        <div>
                                            <h4>
                                                ¿Deseas quitar del curso <span class="modal-certificate__name">{{courseName}}</span><br>
                                                 a <span class="modal-certificate__name">{{ deleteUserModal.userName }}</span> ?
                                            </h4>
                                            <div class="buttons">
                                                <button @click.stop="closeDeleteUserModal">Cancelar</button>
                                                <button @click.stop="handleDeleteUser" :disabled="deleteUserModal.loading">
                                                    <span>Quitar del curso</span><i class="material-icons">arrow_forward</i>
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>
            
            
            
            
                                </tr>
                            </tbody>
                        </table>
                        <div className="management__noResults" v-if="!users.length"
                            style="padding:20px 0 20px 0;text-align:center">No
                            hay resultados para mostrar...</div>
                    </div>
                    <div class="pagination" v-if="totalResults">
                        <button class="prev-next" @click.stop="selectPage('prev')" :disabled="params.page == 0"><i
                                class="material-icons">arrow_back</i><span>Anterior</span> </button>
                        <div class="page"><span>{{ `Página ${params.page + 1 < 10 ? '0' + (params.page + 1) : params.page + 1}` }}</span>{{ ` / ${pages < 10 ? '0' + pages : pages}` }}</div>
                        <button class="prev-next" @click.stop="selectPage('next')"
                            :disabled="params.page + 1 == pages"><span>Siguiente</span> <i
                                class="material-icons">arrow_forward</i>
                        </button>
                    </div>
                </div>
            </template>


            <Modal :isOpen="modalAddUser.active" @close="() => modalAddUser.active = false">
                <div class="modal-add-student">

                    <template v-if="!modalAddUser.error && !modalAddUser.success">
                        <h4>Agregar nuevo usuario</h4>
                        <template v-if="modalAddUser.currentStep === 1">
                            <span>Ingresa el mail del usuario que deseas ingresar:</span>
                            <Input 
                                v-model="modalAddUser.email"
                                label="Email"
                                id="Email"
                                :isError="v$.modalAddUser.email.$invalid"
                                :errorMessage="'Formato de mail inválido'"
                            />
                            <div class="buttons">
                                <button @click.stop="modalAddUser.active = null"><i class="material-icons">arrow_back</i>Atrás</button>
                                <button @click.stop="modalAddUser.currentStep = 2" :disabled="v$.modalAddUser.email.$invalid || !modalAddUser.email.trim().length">
                                    Continuar<i class="material-icons">arrow_forward</i>
                                </button>
                            </div>
                        </template>
                        <template v-if="modalAddUser.currentStep === 2">
                            <span>Indica el rol para <strong class="modal-add-student__strong">{{ modalAddUser.email }}</strong></span>
                            <Select 
                                v-model="modalAddUser.roleId"
                                label="Rol"
                                valueProp="id"
                                valueLabel="name"
                                :values="translatedRoles"
                                :isDropdown="true"
                            />
                            <div class="buttons">
                                <button @click.stop="modalAddUser.currentStep = 1"><i class="material-icons">arrow_back</i>Atrás</button>
                                <button @click.stop="postUser()" :disabled="!modalAddUser.roleId || modalAddUser.loading">
                                    Continuar<i class="material-icons">arrow_forward</i>
                                </button>
                            </div>
                        </template>
                    </template>

                    <template v-if="modalAddUser.error">
                        <div class="modal-add-student__error">
                            <div class="modal-add-student__error__message">
                                <i class="material-icons-outlined">cancel_outline</i>
                                <p>
                                    No es posible agregar al usuario <br/>
                                    <strong>{{ modalAddUser.email }}</strong><br/>
                                </p>
                            </div>
                            <div class="modal-add-student__error__disclaimer">
                                <i class="material-icons-outlined">info</i>
                                <p v-if="modalAddUser.errorType === 'ERROR'">
                                    Ha ocurrido un error inesperado.
                                </p>
                                <p v-if="modalAddUser.errorType === 'USER_NOT_EXISTS'">
                                    Te sugerimos revisar que el usuario esté dado de alta en el sistema de gestón.
                                </p>
                                <p v-if="modalAddUser.errorType === 'USER_ALREADY_IN_COURSE'">
                                    El usuario ya se encuentra en el curso.
                                </p>
                            </div>
                        </div>
                    </template>

                    <template v-if="modalAddUser.success">
                        <div class="modal-add-student__success">
                            <i class="material-icons-outlined">check_circle</i>
                            <p>
                                Se agregó exitosamente a <br/>
                                <strong>{{ modalAddUser.successEmail }}</strong><br/>
                                en el rol de <strong>{{$t(`role.${modalAddUser.successRoleName}`)}}</strong>
                            </p>
                        </div>
                    </template>
                    
                </div>
            </Modal>
        </div>
        <Loader v-else />


    </div>
</template>

<script>
import { inject, onMounted, onBeforeUnmount, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '../../../components/Loader.vue';
import Modal from '../../../components/Modal.vue';
import Input from '../../../components/Input.vue';
import Select from '../../../components/Inputs/Select.vue';
import { email } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useI18n } from 'vue-i18n';
import Tooltip from '@/components/ToolTip.vue';


export default {
    components: {
        Loader,
        Modal,
        Input,
        Select,
        Tooltip,
    },
    setup() {
        const store = useStore();
        const v$ = useVuelidate();
        const router = useRouter();
        const route = useRoute()
        const formatDate = inject('formatDate');
        const copyToClipboard = inject('copyToClipboard');
        const userData = computed(() => store.getters.manageUser_user);
        const stuffRoles = ref();
        const stuffRolesLoaded = ref(false);
        const users = ref()
        const allSelected = ref(false)
        const unsuscribeList = ref([])
        const unsuscribeModal = ref()
        const modalMoveStudent = ref(false)
        const changeEmailModal = ref({})
        const newEmail = ref('')
        const moveStudenList = ref([])
        const certificateLoading = ref(false)
        const alterStateLoading = ref(false)
        const changeEmailSubmitting = ref(false)
        const modalAddUser = ref({
            active: false,
            currentStep: 1,
            email: '',
            roleId: null,
            error: false,
            errorType: '',
            success: false,
            successEmail: '',
            successRoleName: '',
            loading: false
        });
        watch(modalAddUser.value, () => {
            if (!modalAddUser.value.active) {
                modalAddUser.value.fullData = false;
                modalAddUser.value.email = '';
                modalAddUser.value.roleId = null;
            }
        })
        const dataLoaded = ref(false);
        const modalStatusFilters = ref(false);
        const modalCountryFilters = ref(false);
        const modalCoordinatorFilters = ref(false);
        const stageTooltip = ref(null);
        const tooltipAddUser = ref(false);
        const tooltipDeleteUser = ref(false);
        const params = ref({
            page: 0,
            rows: 5,
            status: '',
            courseId: route.params.courseid,
            search: '',
            canCertificate: ''
        })
        const tooltipIndex = ref(null);
        const courseName = ref();
        const { t } = useI18n();


        

        async function postUser() {
            if (!modalAddUser.value.email || !modalAddUser.value.roleId) return; // Validación básica
            try {
                modalAddUser.value.loading = true; // Activar estado de carga

                const courseId = route.params.courseid;

                const data = {
                    email: modalAddUser.value.email,
                    roleId: modalAddUser.value.roleId
                }

                await store.dispatch('coursesInstances_addUser', {courseId, data});
                modalAddUser.value.success = true;
                modalAddUser.value.successEmail = modalAddUser.value.email;
                modalAddUser.value.successRoleName = stuffRoles.value.find(role => role.id === modalAddUser.value.roleId).name;
                modalAddUser.value.roleId = null;
                modalAddUser.value.email = '';

                store.dispatch('notifications_create', { text: 'Usuario agregado correctamente' });
                getUsers()
            } catch (error) {
                console.log(error);
                if (error.response.data == 'USER_NOT_EXISTS') {
                    modalAddUser.value.error = true;
                    modalAddUser.value.errorType = 'USER_NOT_EXISTS';
                    return;
                }
                if (error.response.data == 'USER_ALREADY_IN_COURSE') {
                    modalAddUser.value.error = true;
                    modalAddUser.value.errorType = 'USER_ALREADY_IN_COURSE';
                    return;
                }
                modalAddUser.value.error = true;
                modalAddUser.value.errorType = 'ERROR';
            }  finally {
                modalAddUser.value.loading = false; // Resetear estado de carga
            }
        }


        const deleteUserModal = ref({
            active: false,
            courseId: route.params.courseid,
            forgeUserId: null,
            userName: '',
            success: false,
            successEmail: ''
        });

        const openDeleteUserModal = (forgeUserId, userName) => {
            deleteUserModal.value = {
                active: true,
                courseId: route.params.courseid,
                forgeUserId: forgeUserId,
                userName: userName
            };
        };

        const closeDeleteUserModal = () => {
            deleteUserModal.value = {
                active: false,
                courseId: route.params.courseid,
                forgeUserId: null,
                success: false
            };
        };



        const handleDeleteUser = async () => {
            if (deleteUserModal.value.forgeUserId) {
                try {
                    deleteUserModal.value.loading = true; // Activar estado de carga
                    const data = {
                        courseId: deleteUserModal.value.courseId,
                        forgeUserId: deleteUserModal.value.forgeUserId
                    }
                    await store.dispatch('coursesInstances_deleteUser', data);
                    store.dispatch('notifications_create', {text: 'Usuario eliminado correctamente.'});
                    getUsers(); // Refresh the students list
                } catch (err) {
                    console.log(err);
                    store.dispatch('notifications_create', {text: 'Ocurrió un error durante la eliminación del usuario.'});
                } finally {
                    deleteUserModal.value.loading = false; // Resetear estado de carga
                    closeDeleteUserModal(); // Close the modal after action
                }
            }
        };



        const translatedRoles = computed(() => {
            return stuffRoles.value?.map(role => {
                return {
                    id: role.id,
                    name: t(`role.${role.name}`)
                }
            })
        })

        async function getStuffRoles() {
            try {
                let req = await store.dispatch('stuff_roles');
                stuffRoles.value = req.data;
                stuffRolesLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar opciones de roles' });
            }
        }

        async function getUsers() {
            try {
                dataLoaded.value = false;
                let req = await store.dispatch('coursesInstances_users', params.value);
                users.value = req.data.forgeUsers;
                courseName.value = req.data.courseCode;
                dataLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al obtener los datos' });
            }
        }


        onMounted(() => {
            getUsers();
            getStuffRoles();
            document.body.style.overflowX = 'auto';
            document.body.style.background = '#fff';
        })
        onBeforeUnmount(() => {
            document.body.style.overflowX = 'visible';
            document.body.style.background = '';

        })

        return {
            router,
            formatDate,
            copyToClipboard,
            unsuscribeModal,
            userData,
            modalAddUser,
            dataLoaded,
            translatedRoles,
            stuffRoles,
            stuffRolesLoaded,
            modalStatusFilters,
            modalCountryFilters,
            modalCoordinatorFilters,
            stageTooltip,
            getUsers,
            moveStudenList,
            params,
            users,
            v$,
            postUser,
            route,
            unsuscribeList,
            allSelected,
            modalMoveStudent,
            handleDeleteUser,
            deleteUserModal,
            openDeleteUserModal,
            closeDeleteUserModal,
            alterStateLoading,
            certificateLoading,
            changeEmailModal,
            changeEmailSubmitting,
            newEmail,
            tooltipIndex,
            tooltipAddUser,
            tooltipDeleteUser,
            courseName
        }
    },
    validations() {
        return {
            modalAddUser: {
                email: { email }
            },
            newEmail: { email }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';


.back-route{
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

.disabled{
    opacity: .6;
    cursor: default !important;
}

.main-container {
    padding: 8px;
    background: #fff;
    min-height: fit-content;
}

.selected__actions{
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    justify-content: flex-end;
    height: 37px;
    button{
        border: 1px solid $green;
        border-radius: 44px;
        font-size: 16px;
        font-weight: 600;
        color: $green;
        padding: 8px 0;
        min-width: 149px;
        &:disabled{
            cursor: default;
        }
    }
}

.dropdown{
    &__items{
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        z-index: 2;
        font-size: 13px;
        font-weight: 600;
        border: none;
        li{
            padding: 4px 24px;
            cursor: pointer;
            &:hover{
                background: rgba(189, 228, 228, 0.5);
            }
        }
        @media screen and (max-width: 750px) {
            right: 0 !important;
        }
    }
}

.moveStudent{
    width: 100%;
    max-width: 460px;
    padding: 28px 40px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    &__title{
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
    }
    &__datas{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    &__data{
        font-size: 12px;
        font-weight: 400;
        strong{
            font-weight: 700;
        }
    }
}

.table__modal-options {
    position: absolute;
    top: 50px;
    right: 2px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    padding: 6px 0;
    >div {
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 22px;
        &:hover {
            background: rgba(189, 228, 228, 0.5);
        }
    }
}


.management {
    &__noResults {
        display: grid;
        padding: 20px 0 20px 0;
        text-align: center;
        grid-column-start: 1;
        grid-column-end: 7;
    }

}

.create-new {
    margin-right: 8px;
    color: $green;
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    .material-icons {
        font-size: 15px;
    }
}

.cohorte_data{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    >span{
        font-size: 18px;
        font-weight: 400;
        strong{
            font-weight: 400;
            color: $green;
        }
    }
}
.modal__inner{
    max-width: 420px;
}

.modal-add-student{
    position: relative;
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    border-radius: 10px;

    &__strong{
        font-weight: 700;
        color: $green;
        font-style: italic;
    }

    &__error{
        display: flex;
        flex-direction: column;
        gap: 16px;
        line-height: 32px;

        &__message{
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 12px;

            i{
                color: $red;
                font-size: 24px;
                width: 24px;
            }
        }
        
        &__disclaimer{
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            gap: 12px;
            background: #FFBDB080;
            max-width: 377px;
            padding: 16px;
            border-radius: 10px;
            i{
                color: $red;
                font-size: 24px;
            }
        }
    }

    &__success {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
        line-height: 32px;
        i{
            color: $green;
            font-size: 24px;
        }
        strong{
            font-weight: 700;
            color: $green;
        }
    }
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
    }
    span{
        font-weight: 400;
        font-size: 13px;
    }
    .buttons{
        display: flex;
        justify-content: center;
        gap: 24px;
        padding-top: 16px;
        button{
            width: 152px;
            padding: 8px 0;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}


.modal-certificate {

    .modal__inner {
        max-width: unset;
    }
    
    &__name {
        font-style: italic;
        color: $green;
        text-transform: capitalize;
        font-weight: 700;
    }
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        font-size: 16px;
        text-align: center;
        font-weight: 400;
    }
    
    .buttons{
        display: flex;
        justify-content: center;
        gap: 8px;
        padding-top: 16px;
        button{
            min-width: 152px;
            padding: 8px 16px;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}

.pills{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    .pill{
        padding: 6px 10px 6px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        font-size: 13px;
        background-color: $whitegray;
        border: 1px solid #000;
        border-radius: 50px;
        min-width: 150px;
        gap: 12px;
        .material-icons-outlined{
            font-size: 16px;
            cursor: pointer;
        }
    }
}

.preregistrations {
    width: fit-content;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    h1 {
        font-size: 25px;
        font-weight: 700;
    }

    .tabs {
        display: flex;
        margin: 30px 0;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

        >div {
            height: 60px;
            width: 180px;
            @include flex-column;
            justify-content: center;
            font-size: 15px;
            font-weight: 600;

            &.--selected {
                color: $green;
                border-bottom: 2px solid $green;
            }
        }
    }

    .new-and-filter {
        position: relative;
        min-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__search{
            input{
                border: none;
                &::placeholder{
                    font-size: 12px;
                }
            }
            border: 1px solid $black;
            padding: 6px 18px;
            border-radius: 999px;
            display: flex;
            align-items: center;
            .material-icons-outlined{
                position: absolute;
                font-size: 14px;
                right: 18px;
            }
        }
        h3 {
            font-size: 20px;
        }

        &__btns {
            display: flex;
            gap: 16px;
            align-items: center;
            @media screen and (max-width: 750px) {
                @include flex-column;
                padding-bottom: 16px;
            }

            button {
                @include icon-and-text-container;
                font-size: 12px;
                &.open-filters {
                    border: 1px solid;
                    border-radius: 16px;
                    padding: 6px 18px;
                    font-weight: 400;
                    gap: 18px;
                    height: fit-content;

                    .material-icons {
                        font-size: 18px;
                    }
                }
            }
        }

        .modal-filters {
            position: absolute;
            top: 50px;
            padding: 8px 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
            background: #fff;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 10px;
            z-index: 2;
            font-size: 13px;
            font-weight: 600;

            div {
                padding: 4px 24px;
                cursor: pointer;

                &:hover {
                    background: rgba(189, 228, 228, 0.5);
                }
            }

            @media screen and (max-width: 750px) {
                right: 0 !important;
            }
        }

        .modal-country-filters {
            right: 126px;
        }

        .modal-coordinator-filters {
            right: 240px;
        }

        .modal-status-filters {
            right: 0;
        }
    }


    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }

    @media(max-width:980px) {
        .table__container {
            overflow-x: auto;
        }
    }

    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;

        th, td {
            padding: 16px;
        }

        &__head {
            
            
            &__row {
                th {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 14px;
                    text-align: left;


                    &.table__head__row__stage {
                    position: relative;

                    .material-icons-outlined{
                        font-size: 14px;
                    }
                    .stage-tooltip{
                        width: 200px;
                        position: absolute;
                        right: -36px;
                        padding: 18px 14px 26px 14px;
                        background: #BDE4E4;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        text-align: left;
                        font-size: 11px;
                        font-weight: 400;
                        z-index: 100;
                        h4{
                            padding-bottom: 4px;
                            font-size: 13px;
                            font-weight: 700;
                        }
                    }
                }
                }
            }
        }

        &__body {
            tr {
                position: relative;
                &:last-child td {
                    border-bottom: none;
                }
                td {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                    text-align: left;
                    border-bottom: 1px solid #eee;

                    


                    &.table__body__row__status{
                    padding-top: 4px !important;
                        span{
                            display: inline-block;
                            width: 100px;
                            padding: 4px 0;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--Active, &.--Reactivated{
                                background-color: #EFE2EE;
                                color: #9E5498;
                            }
                            &.--Finished, &.--certificate{
                                color: #009696;
                                background: rgba(189, 228, 228, 0.50);
                            }
                            &.--Inactive{
                                background: rgba(255, 178, 63, 0.15);
                                color: #FFB23F;
                            }
                        }
                    }
                

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        position: relative;

                        .material-icons {
                            color: $green;
                        }
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }


    .unsuscribeUser{
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 460px;
        padding: 0 40px;
        h3{
            font-weight: 700;
            font-size: 16px;
        }
        span{
            font-size: 14px;
        }
        &__buttons{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            gap: 24px;
            button{
                border: 1px solid $green;
                text-align: center;
                width: fit-content;
                display: flex;
                align-items: center;
                gap: 12px;
                border-radius: 999px;
                padding: 12px 18px;
                .material-icons-outlined{
                    font-size: 18px;
                }
                &:first-child{
                    color: $green;
                }
                &:last-child{
                    color: #fff;
                    background-color: $green;
                }
            }
        }
    }
}
.tooltip-icon {
    font-size: 16px;
    position: relative;
    top: 3px;
}
</style>